import { useEffect, useMemo, useState } from "react"
import { Input, Button, Table, Modal, Space, Popconfirm, Form } from 'antd'
import { useForm } from "antd/lib/form/Form"
import FormItem from "antd/lib/form/FormItem"
import { axiosTable, baseAxiosComplete } from "../../tool/axios"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import _ from 'lodash'

const { Column } = Table

type fetchParams = {

}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {

    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    const [data, setData] = useState<any>([])
    const [loading, setLoading] = useState<boolean>(false)

    const [editVisible, setEditVisible] = useState<boolean>(false)
    const [activeRow, setActiveRow] = useState<undefined | { room_type_id: string, room_type_name: string }>()

    const [form] = useForm()

    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        axiosTable.get('/keeper/room/type/list', {

        }).then((response: any) => {
            if (response) {
                setData(response)
            }

            setLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    return (<div className="common-page">
        {/* 管家中心 -> 客房配置 -> 房型管理 */}
        <BreadCrumb position={['管家中心', '房型管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                {permission.includes('添加') && <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary" onClick={() => {
                    form.setFieldsValue({ room_type_name: undefined })
                    setActiveRow(undefined)
                    setEditVisible(true)
                }} >添加</Button>}
            </Space>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="id" pagination={false} onChange={handleTableChange}>
                <Column title="房型名称" dataIndex="room_type_name" key="room_type_name" />
                <Column title="创建人" dataIndex="create_user_name" key="create_user_name" />
                <Column title="更新时间" dataIndex="update_time" key="update_time" />

                {/* <Column title="操作" render={(v: any) => {
                    return <Space>
                        {permission.includes('编辑') && <Button onClick={() => {
                            setEditVisible(true)
                            form.setFieldsValue({ room_type_name: v.room_type_name })
                            setActiveRow({ room_type_id: v.room_type_id, room_type_name: v.room_type_name })
                        }} type="primary" size="small">编辑</Button>}

                        {permission.includes('删除') && <Popconfirm
                            title="确定删除?"
                            onConfirm={() => {
                                baseAxiosComplete.post('/keeper/room/type/delete', {
                                    room_type_id: v.room_type_id
                                }).then(res => {
                                    if (res.status === 0) {
                                        resetForm()
                                    }
                                })
                            }}
                            okText="是"
                            cancelText="否"
                        >
                            <Button size="small">删除</Button>
                        </Popconfirm>}
                    </Space>
                }}
                /> */}
            </Table>
        </div>

        <Modal zIndex={10} width={400} title={activeRow ? "编辑房型" : "添加房型"} visible={editVisible} onCancel={() => { setEditVisible(false) }} onOk={() => {
            if (form.getFieldValue('room_type_name')) {
                baseAxiosComplete.post(activeRow?.room_type_id ? '/keeper/room/type/update' : '/keeper/room/type/add', {
                    room_type_id: activeRow?.room_type_id ? activeRow.room_type_id : null,
                    room_type_name: form.getFieldValue('room_type_name')

                }).then(res => {
                    if (res.status === 0) {
                        resetForm()
                        setEditVisible(false)
                    }
                })
            }
        }}>
            <Form form={form}>
                <FormItem name="room_type_name" rules={[{ required: true, message: '房型名称必填' }]}>
                    <Input placeholder="房型名称" />
                </FormItem>
            </Form>
        </Modal>
    </div>)
}